// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { toast } from "sonner";
// import { FaCheckCircle, FaEye } from "react-icons/fa";
// import { MdCheckCircle, MdCancel } from "react-icons/md";

// const SuperAdminJobSeekerDetails = () => {
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

//   // Fetch job seekers
//   useEffect(() => {
//     const fetchJobSeekers = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         setJobSeekers(response.data);
//       } catch (err) {
//         setError(err.message || "Failed to fetch job seekers");
//         toast.error("Error fetching job seekers");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobSeekers();
//   }, []);

//   // Toggle isVerified status
//   const toggleVerification = async (jobSeekerId, currentStatus) => {
//     try {
//       const response = await axios.patch(
//         `${process.env.REACT_APP_API_URL}jobseeker/updateJobSeeker/${jobSeekerId}`,
//         { isVerified: !currentStatus },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setJobSeekers((prev) =>
//         prev.map((js) =>
//           js._id === jobSeekerId ? { ...js, isVerified: response.data.isVerified } : js
//         )
//       );
//       toast.success(`Job seeker ${currentStatus ? "unverified" : "verified"} successfully`);
//     } catch (err) {
//       toast.error("Error updating verification status");
//     }
//   };

//   // Check if fields are filled
//   const isFieldFilled = (value) => (value && value !== "none" ? true : false);

//   // Render file view icon
//   const renderFileIcon = (url) => {
//     if (!url || url === "none") return <MdCancel className="text-red-500" />;
//     return (
//       <a href={url} target="_blank" rel="noopener noreferrer">
//         <FaEye className="text-blue-500 hover:text-blue-700" />
//       </a>
//     );
//   };

//   // Handle details toggle
//   const toggleDetails = (jobSeeker) => {
//     setSelectedJobSeeker(selectedJobSeeker?._id === jobSeeker._id ? null : jobSeeker);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
    
//       {loading ? (
//         <p className="text-gray-500">Loading job seekers...</p>
//       ) : error ? (
//         <p className="text-red-500">Error: {error}</p>
//       ) : jobSeekers.length > 0 ? (
//         <div className="bg-white p-6 rounded-lg shadow-lg">
//         <div className="flex flex-wrap">
//            <FaCheckCircle className="text-green-500" />: this is for verified
//         </div>

//          <div className="flex flex-wrap">
//            <FaEye className="text-blue-500" />: this is for file and pictures that are verified
//           </div>
//        <div className="flex flex-wrap">
//             <MdCancel className="text-red-500" />: this is for unverified
//          </div>
       
   
      
//           <table className="w-full text-sm md:text-base">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="py-2 px-4 text-left">Name</th>
//                 <th className="py-2 px-4 text-left">Voter's Card</th>
//                 <th className="py-2 px-4 text-left">Residential Card</th>
//                 <th className="py-2 px-4 text-left">Bank Details</th>
//                 <th className="py-2 px-4 text-left">NIN</th>
//                 <th className="py-2 px-4 text-left">E-Verify</th>
//                 <th className="py-2 px-4 text-left">Police Check</th>
//                 <th className="py-2 px-4 text-left">Passport</th>
//                 <th className="py-2 px-4 text-left">Next of Kin</th>
//                 <th className="py-2 px-4 text-left">Verified</th>
//                 <th className="py-2 px-4 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {jobSeekers.map((js) => (
//                 <React.Fragment key={js._id}>
//                   <tr className="border-t">
//                     <td className="py-2 px-4">{`${js.firstName} ${js.lastName}`}</td>
//                     <td className="py-2 px-4">
//                       {renderFileIcon(js.votersCard)}
//                     </td>
//                     <td className="py-2 px-4">
//                       {renderFileIcon(js.residentialCard)}
//                     </td>
//                     <td className="py-2 px-4">
//                       {isFieldFilled(js.bankName) &&
//                       isFieldFilled(js.bankAcctName) &&
//                       isFieldFilled(js.bankAcctNum) ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       {isFieldFilled(js.nin) ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       {isFieldFilled(js.registeredEverify) ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       {isFieldFilled(js.criminalRecord) ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       {renderFileIcon(js.avatar)}
//                     </td>
//                     <td className="py-2 px-4">
//                       {isFieldFilled(js.nextOfKin) &&
//                       isFieldFilled(js.nextOfKinNumber) &&
//                       isFieldFilled(js.nextOfKinAddress) &&
//                       isFieldFilled(js.nextOfKinRelationship) ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       {js.isVerified ? (
//                         <MdCheckCircle className="text-green-500" />
//                       ) : (
//                         <MdCancel className="text-red-500" />
//                       )}
//                     </td>
//                     <td className="py-2 px-4">
//                       <button
//                         onClick={() => toggleVerification(js._id, js.isVerified)}
//                         className={`px-3 py-1 rounded-md text-white ${
//                           js.isVerified ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                         }`}
//                       >
//                         {js.isVerified ? "Unverify" : "Verify"}
//                       </button>
//                       <button
//                         onClick={() => toggleDetails(js)}
//                         className="ml-2 px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//                       >
//                         {selectedJobSeeker?._id === js._id ? "Hide Details" : "Show Details"}
//                       </button>
//                     </td>
//                   </tr>
//                   {selectedJobSeeker?._id === js._id && (
//                     <tr>
//                       <td colSpan="11" className="py-4 px-4 bg-gray-50">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                           <div>
//                             <h4 className="font-semibold">Personal Details</h4>
//                             <p><strong>Name:</strong> {`${js.firstName} ${js.middleName || ""} ${js.lastName}`}</p>
//                             <p><strong>Email:</strong> {js.email}</p>
//                             <p><strong>Phone:</strong> {js.phoneNumber}</p>
//                             <p><strong>Address:</strong> {js.address}</p>
//                             <p><strong>Date of Birth:</strong> {js.dateOfBirth || "N/A"}</p>
//                             <p><strong>Gender:</strong> {js.gender}</p>
//                             <p><strong>Race:</strong> {js.race || "N/A"}</p>
//                             <p><strong>Disability:</strong> {js.dissability || "N/A"}</p>
//                           </div>
//                           <div>
//                             <h4 className="font-semibold">Additional Details</h4>
//                             <p><strong>Bank:</strong> {js.bankName || "N/A"} ({js.bankAcctName || "N/A"}, {js.bankAcctNum || "N/A"})</p>
//                             <p><strong>NIN:</strong> {js.nin || "N/A"}</p>
//                             <p><strong>E-Verify:</strong> {js.registeredEverify || "N/A"}</p>
//                             <p><strong>Police Check:</strong> {js.criminalRecord || "N/A"} {js.criminalRecord === "Yes" && `(${js.incident}, ${js.natureOfOffence}, ${js.when ? new Date(js.when).toLocaleDateString() : "N/A"}, ${js.where || "N/A"})`}</p>
//                             <p><strong>Next of Kin:</strong> {js.nextOfKin || "N/A"} ({js.nextOfKinNumber || "N/A"}, {js.nextOfKinAddress || "N/A"}, {js.nextOfKinRelationship || "N/A"})</p>
//                           </div>
//                           <div>
//                             <h4 className="font-semibold">Files</h4>
//                             <p>
//                               <strong>Voter's Card:</strong>{" "}
//                               {js.votersCard ? (
//                                 <a href={js.votersCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//                                   View
//                                 </a>
//                               ) : (
//                                 "Not uploaded"
//                               )}
//                             </p>
//                             <p>
//                               <strong>Residential Card:</strong>{" "}
//                               {js.residentialCard ? (
//                                 <a href={js.residentialCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//                                   View
//                                 </a>
//                               ) : (
//                                 "Not uploaded"
//                               )}
//                             </p>
//                             <p>
//                               <strong>Passport:</strong>{" "}
//                               {js.avatar ? (
//                                 <a href={js.avatar} target="_blank" rel="noopener noreferrer" className="text-blue-500">
//                                   View
//                                 </a>
//                               ) : (
//                                 "Not uploaded"
//                               )}
//                             </p>
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p className="text-gray-500">No job seekers available.</p>
//       )}
//     </div>
//   );
// };

// export default SuperAdminJobSeekerDetails;








import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FaCheckCircle, FaEye } from "react-icons/fa";
import { MdCheckCircle, MdCancel } from "react-icons/md";

const SuperAdminJobSeekerDetails = () => {
  const [jobSeekers, setJobSeekers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

  // Fetch job seekers
  useEffect(() => {
    const fetchJobSeekers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setJobSeekers(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch job seekers");
        toast.error("Error fetching job seekers");
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  // Toggle isVerified status
  const toggleVerification = async (jobSeekerId, currentStatus) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}jobseeker/updateJobSeeker/${jobSeekerId}`,
        { isVerified: !currentStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setJobSeekers((prev) =>
        prev.map((js) =>
          js._id === jobSeekerId ? { ...js, isVerified: response.data.isVerified } : js
        )
      );
      toast.success(`Job seeker ${currentStatus ? "unverified" : "verified"} successfully`);
    } catch (err) {
      toast.error("Error updating verification status");
    }
  };

  // Check if fields are filled
  const isFieldFilled = (value) => (value && value !== "none" ? true : false);

  // Render file view icon
  const renderFileIcon = (url) => {
    if (!url || url === "none") return <MdCancel className="text-red-500" />;
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        <FaEye className="text-blue-500 hover:text-blue-700" />
      </a>
    );
  };

  // Handle details toggle
  const toggleDetails = (jobSeeker) => {
    setSelectedJobSeeker(selectedJobSeeker?._id === jobSeeker._id ? null : jobSeeker);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6">

      {loading ? (
        <p className="text-gray-500">Loading job seekers...</p>
      ) : error ? (
        <p className="text-red-500">Error: {error}</p>
      ) : jobSeekers.length > 0 ? (
        <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg">
        <div className="flex flex-wrap items-center gap-1">
           <FaCheckCircle className="text-green-500" />: this is for verified
        </div>

         <div className="flex flex-wrap items-center gap-1">
           <FaEye className="text-blue-500" />: this is for file and pictures that are verified
          </div>
       <div className="flex flex-wrap items-center gap-1">
            <MdCancel className="text-red-500" />: this is for unverified
         </div>

          {/* ── Desktop / tablet table — unchanged, just hidden on mobile ── */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm md:text-base">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 text-left">Name</th>
                  <th className="py-2 px-4 text-left">Voter's Card</th>
                  <th className="py-2 px-4 text-left">Residential Card</th>
                  <th className="py-2 px-4 text-left">Bank Details</th>
                  <th className="py-2 px-4 text-left">NIN</th>
                  <th className="py-2 px-4 text-left">E-Verify</th>
                  <th className="py-2 px-4 text-left">Police Check</th>
                  <th className="py-2 px-4 text-left">Passport</th>
                  <th className="py-2 px-4 text-left">Next of Kin</th>
                  <th className="py-2 px-4 text-left">Verified</th>
                  <th className="py-2 px-4 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {jobSeekers.map((js) => (
                  <React.Fragment key={js._id}>
                    <tr className="border-t">
                      <td className="py-2 px-4">{`${js.firstName} ${js.lastName}`}</td>
                      <td className="py-2 px-4">
                        {renderFileIcon(js.votersCard)}
                      </td>
                      <td className="py-2 px-4">
                        {renderFileIcon(js.residentialCard)}
                      </td>
                      <td className="py-2 px-4">
                        {isFieldFilled(js.bankName) &&
                        isFieldFilled(js.bankAcctName) &&
                        isFieldFilled(js.bankAcctNum) ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        {isFieldFilled(js.nin) ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        {isFieldFilled(js.registeredEverify) ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        {isFieldFilled(js.criminalRecord) ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        {renderFileIcon(js.avatar)}
                      </td>
                      <td className="py-2 px-4">
                        {isFieldFilled(js.nextOfKin) &&
                        isFieldFilled(js.nextOfKinNumber) &&
                        isFieldFilled(js.nextOfKinAddress) &&
                        isFieldFilled(js.nextOfKinRelationship) ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        {js.isVerified ? (
                          <MdCheckCircle className="text-green-500" />
                        ) : (
                          <MdCancel className="text-red-500" />
                        )}
                      </td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => toggleVerification(js._id, js.isVerified)}
                          className={`px-3 py-1 rounded-md text-white ${
                            js.isVerified ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
                          }`}
                        >
                          {js.isVerified ? "Unverify" : "Verify"}
                        </button>
                        <button
                          onClick={() => toggleDetails(js)}
                          className="ml-2 px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                        >
                          {selectedJobSeeker?._id === js._id ? "Hide Details" : "Show Details"}
                        </button>
                      </td>
                    </tr>
                    {selectedJobSeeker?._id === js._id && (
                      <tr>
                        <td colSpan="11" className="py-4 px-4 bg-gray-50">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <h4 className="font-semibold">Personal Details</h4>
                              <p><strong>Name:</strong> {`${js.firstName} ${js.middleName || ""} ${js.lastName}`}</p>
                              <p><strong>Email:</strong> {js.email}</p>
                              <p><strong>Phone:</strong> {js.phoneNumber}</p>
                              <p><strong>Address:</strong> {js.address}</p>
                              <p><strong>Date of Birth:</strong> {js.dateOfBirth || "N/A"}</p>
                              <p><strong>Gender:</strong> {js.gender}</p>
                              <p><strong>Race:</strong> {js.race || "N/A"}</p>
                              <p><strong>Disability:</strong> {js.dissability || "N/A"}</p>
                            </div>
                            <div>
                              <h4 className="font-semibold">Additional Details</h4>
                              <p><strong>Bank:</strong> {js.bankName || "N/A"} ({js.bankAcctName || "N/A"}, {js.bankAcctNum || "N/A"})</p>
                              <p><strong>NIN:</strong> {js.nin || "N/A"}</p>
                              <p><strong>E-Verify:</strong> {js.registeredEverify || "N/A"}</p>
                              <p><strong>Police Check:</strong> {js.criminalRecord || "N/A"} {js.criminalRecord === "Yes" && `(${js.incident}, ${js.natureOfOffence}, ${js.when ? new Date(js.when).toLocaleDateString() : "N/A"}, ${js.where || "N/A"})`}</p>
                              <p><strong>Next of Kin:</strong> {js.nextOfKin || "N/A"} ({js.nextOfKinNumber || "N/A"}, {js.nextOfKinAddress || "N/A"}, {js.nextOfKinRelationship || "N/A"})</p>
                            </div>
                            <div>
                              <h4 className="font-semibold">Files</h4>
                              <p>
                                <strong>Voter's Card:</strong>{" "}
                                {js.votersCard ? (
                                  <a href={js.votersCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                                    View
                                  </a>
                                ) : (
                                  "Not uploaded"
                                )}
                              </p>
                              <p>
                                <strong>Residential Card:</strong>{" "}
                                {js.residentialCard ? (
                                  <a href={js.residentialCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                                    View
                                  </a>
                                ) : (
                                  "Not uploaded"
                                )}
                              </p>
                              <p>
                                <strong>Passport:</strong>{" "}
                                {js.avatar ? (
                                  <a href={js.avatar} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                                    View
                                  </a>
                                ) : (
                                  "Not uploaded"
                                )}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── Mobile card layout — new, mirrors the table above field for field ── */}
          <div className="md:hidden space-y-4 mt-4">
            {jobSeekers.map((js) => (
              <div key={js._id} className="bg-white rounded-lg shadow border border-gray-200 p-4">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold text-gray-900">{`${js.firstName} ${js.lastName}`}</h3>
                  {js.isVerified ? (
                    <MdCheckCircle className="text-green-500 text-xl" />
                  ) : (
                    <MdCancel className="text-red-500 text-xl" />
                  )}
                </div>

                <div className="grid grid-cols-2 gap-y-2 gap-x-3 text-sm mb-3">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Voter's Card</span>
                    {renderFileIcon(js.votersCard)}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Residential Card</span>
                    {renderFileIcon(js.residentialCard)}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Bank Details</span>
                    {isFieldFilled(js.bankName) &&
                    isFieldFilled(js.bankAcctName) &&
                    isFieldFilled(js.bankAcctNum) ? (
                      <MdCheckCircle className="text-green-500" />
                    ) : (
                      <MdCancel className="text-red-500" />
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">NIN</span>
                    {isFieldFilled(js.nin) ? (
                      <MdCheckCircle className="text-green-500" />
                    ) : (
                      <MdCancel className="text-red-500" />
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">E-Verify</span>
                    {isFieldFilled(js.registeredEverify) ? (
                      <MdCheckCircle className="text-green-500" />
                    ) : (
                      <MdCancel className="text-red-500" />
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Police Check</span>
                    {isFieldFilled(js.criminalRecord) ? (
                      <MdCheckCircle className="text-green-500" />
                    ) : (
                      <MdCancel className="text-red-500" />
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Passport</span>
                    {renderFileIcon(js.avatar)}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-500">Next of Kin</span>
                    {isFieldFilled(js.nextOfKin) &&
                    isFieldFilled(js.nextOfKinNumber) &&
                    isFieldFilled(js.nextOfKinAddress) &&
                    isFieldFilled(js.nextOfKinRelationship) ? (
                      <MdCheckCircle className="text-green-500" />
                    ) : (
                      <MdCancel className="text-red-500" />
                    )}
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={() => toggleVerification(js._id, js.isVerified)}
                    className={`flex-1 px-3 py-2 rounded-md text-white text-sm ${
                      js.isVerified ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
                    }`}
                  >
                    {js.isVerified ? "Unverify" : "Verify"}
                  </button>
                  <button
                    onClick={() => toggleDetails(js)}
                    className="flex-1 px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm"
                  >
                    {selectedJobSeeker?._id === js._id ? "Hide Details" : "Show Details"}
                  </button>
                </div>

                {selectedJobSeeker?._id === js._id && (
                  <div className="mt-3 pt-3 border-t border-gray-200 space-y-4 text-sm">
                    <div>
                      <h4 className="font-semibold mb-1">Personal Details</h4>
                      <p><strong>Name:</strong> {`${js.firstName} ${js.middleName || ""} ${js.lastName}`}</p>
                      <p><strong>Email:</strong> {js.email}</p>
                      <p><strong>Phone:</strong> {js.phoneNumber}</p>
                      <p><strong>Address:</strong> {js.address}</p>
                      <p><strong>Date of Birth:</strong> {js.dateOfBirth || "N/A"}</p>
                      <p><strong>Gender:</strong> {js.gender}</p>
                      <p><strong>Race:</strong> {js.race || "N/A"}</p>
                      <p><strong>Disability:</strong> {js.dissability || "N/A"}</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">Additional Details</h4>
                      <p><strong>Bank:</strong> {js.bankName || "N/A"} ({js.bankAcctName || "N/A"}, {js.bankAcctNum || "N/A"})</p>
                      <p><strong>NIN:</strong> {js.nin || "N/A"}</p>
                      <p><strong>E-Verify:</strong> {js.registeredEverify || "N/A"}</p>
                      <p><strong>Police Check:</strong> {js.criminalRecord || "N/A"} {js.criminalRecord === "Yes" && `(${js.incident}, ${js.natureOfOffence}, ${js.when ? new Date(js.when).toLocaleDateString() : "N/A"}, ${js.where || "N/A"})`}</p>
                      <p><strong>Next of Kin:</strong> {js.nextOfKin || "N/A"} ({js.nextOfKinNumber || "N/A"}, {js.nextOfKinAddress || "N/A"}, {js.nextOfKinRelationship || "N/A"})</p>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">Files</h4>
                      <p>
                        <strong>Voter's Card:</strong>{" "}
                        {js.votersCard ? (
                          <a href={js.votersCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                            View
                          </a>
                        ) : (
                          "Not uploaded"
                        )}
                      </p>
                      <p>
                        <strong>Residential Card:</strong>{" "}
                        {js.residentialCard ? (
                          <a href={js.residentialCard} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                            View
                          </a>
                        ) : (
                          "Not uploaded"
                        )}
                      </p>
                      <p>
                        <strong>Passport:</strong>{" "}
                        {js.avatar ? (
                          <a href={js.avatar} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                            View
                          </a>
                        ) : (
                          "Not uploaded"
                        )}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-gray-500">No job seekers available.</p>
      )}
    </div>
  );
};

export default SuperAdminJobSeekerDetails;